export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR'
  }).format(price);
};

// Modified to avoid formatting while the field is being edited
export const formatNumber = (value: number, decimals: number = 2): string => {
  // Return empty string if undefined, null, or NaN to avoid confusing users
  if (value === undefined || value === null || isNaN(value)) {
    return '';
  }
  
  return new Intl.NumberFormat('nl-NL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value);
};

// Improved parser with better handling for editing
export const parseNumber = (value: string | undefined): number | null => {
  if (!value) return null;
  
  // Remove any currency symbols and spaces
  const cleanValue = value.replace(/[€\s]/g, '');
  
  // For Dutch format, replace dots (thousand separators) with nothing and commas (decimal separator) with dots
  // Only do this if the value contains both dots and commas, or just dots in thousand positions
  let processedValue = cleanValue;
  
  if (cleanValue.includes('.') && cleanValue.includes(',')) {
    // Dutch format with both thousand separators and decimal
    processedValue = cleanValue.replace(/\./g, '').replace(',', '.');
  } else if (cleanValue.includes('.') && !/,/.test(cleanValue)) {
    // Only has dots, determine if it's a thousand separator or decimal point
    const lastDotIndex = cleanValue.lastIndexOf('.');
    if (lastDotIndex > cleanValue.length - 4) {
      // If the last dot is followed by at most 2 digits, it's likely a decimal point in English format
      processedValue = cleanValue;
    } else {
      // Otherwise, replace all dots (thousand separators)
      processedValue = cleanValue.replace(/\./g, '');
    }
  } else if (cleanValue.includes(',')) {
    // Only has comma as decimal separator
    processedValue = cleanValue.replace(',', '.');
  }
  
  const parsed = Number(processedValue);
  return isNaN(parsed) ? null : parsed;
};

/**
 * Calculate the expected delivery date based on order date and delivery time in days
 * @param orderDate Order creation date
 * @param levertijdDagen Delivery time in days
 * @returns Formatted expected delivery date
 */
export const calculateExpectedDeliveryDate = (orderDate: string, levertijdDagen?: number | null): string => {
  if (!levertijdDagen) return 'Onbekend';
  
  try {
    const date = new Date(orderDate);
    if (isNaN(date.getTime())) {
      console.error('Invalid order date:', orderDate);
      return 'Onbekend';
    }
    
    date.setDate(date.getDate() + levertijdDagen);
    
    // Format date as DD-MM-YYYY
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}-${month}-${year}`;
  } catch (error) {
    console.error('Error calculating delivery date:', error);
    return 'Onbekend';
  }
};
